import * as types from '../../mutation-types'
import * as api from '../../api'

const state = {
  services: [],
  services_received_timestamp: new Date(0)
}

const getters = {
  allServices: state => state.services
}

const actions = {
  getServices ({ commit }) {
    const diff = Math.abs(new Date(state.services_received_timestamp) - new Date())
    const diffMinutes = Math.floor((diff / 1000) / 60)
    if (diffMinutes >= 0.15) {
      api.instance.get('services')
        .then(function (response) {
          const services = response.data.services
          commit(types.RECEIVE_SERVICES, services)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  restartService ({ commit }, service) {
    commit(types.RESTART_SERVICE, service)
    api.instance.post('services/' + service.id)
      .then(function (response) {
      })
      .catch(function (error) {
        console.log(error)
      })
  }
}

const mutations = {
  [types.RECEIVE_SERVICES] (state, services) {
    state.services = services
    state.services_received_timestamp = Date.now()
  },
  [types.RESTART_SERVICE] (state, service) {
    service.status = 0

    let serviceToEdit = state.services.find(
      function (ele) {
        if (ele.id === service.id) {
          return true
        }
      }
    )
    let index = state.services.indexOf(serviceToEdit)
    state.services[index] = service
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
